PaginationDirective.$inject = ['$location'];
function PaginationDirective($location) {
    return {
        template: require('./views/pagination.html'),
        scope: {
            items: '=',
            key: '@',
            label: '@',
            showSearch: '='
        },
        link: function (scope, element, attrs) {
            var PAGESIZE_KEY;
            var size = 20;
            scope.pgsizes = [5, 10, 15, 20, 50];
            scope.$watchGroup(['items._meta', 'key'], function () {
                scope.total = 0;
                PAGESIZE_KEY = scope.key ? (scope.key + ':pagesize') : 'pagesize';
                if (scope.items && scope.items._meta) {
                    scope.total = scope.items._meta.total;
                    // scope.page = Number($location.search().page) || Number(localStorage.getItem(PAGENUM_KEY)) || 1;
                    scope.page = Number($location.search().page) || 1;
                    scope.limit = Number($location.search().size) || Number(localStorage.getItem(PAGESIZE_KEY)) || size;
                    scope.lastPage = scope.limit ? Math.ceil(scope.total / scope.limit) : scope.page;
                    scope.from = (scope.page - 1) * scope.limit + 1;
                    scope.to = Math.min(scope.total, scope.from + scope.limit - 1);
                }
            });
            scope.setPage = function (page) {
                if (page > 1) {
                    // localStorage.setItem(PAGENUM_KEY, page);
                    $location.search('page', page);
                }
                else {
                    // localStorage.removeItem(PAGENUM_KEY);
                    $location.search('page', null);
                }
            };
            scope.setLimit = function (pagesize) {
                localStorage.setItem(PAGESIZE_KEY, pagesize);
                scope.setPage(0);
                $location.search('size', pagesize != null ? pagesize : size);
            };
            scope.qsearch = $location.search().q || '';
            scope.search = function (q) {
                // localStorage.setItem(STORAGE_KEY, q ? q : '');
                scope.setPage(0);
                $location.search('q', q);
            };
            scope.handleEnter = function ($event) {
                if ($event.keyCode === 13) {
                    if (scope.qsearch.length > 0) {
                        scope.search(scope.qsearch);
                    }
                    else {
                        scope.search(null);
                    }
                }
            };
        }
    };
}
angular.module('rinca.core.directives.pagination', [])
    .directive('rcPagination', PaginationDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/PaginationDirective.js
// module id = 303
// module chunks = 0